import {injectable} from 'inversify';

import type {ReviewConfig, ReviewService, Trigger} from './types';

@injectable()
export class AppStoreReviewService implements ReviewService {
  requestReviewIfNeeded(_trigger: Trigger, _config?: ReviewConfig) {
    return Promise.resolve();
  }
}
